"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _get = _interopRequireDefault(require("lodash/get"));
var _InterestBalancesTableComponent = _interopRequireDefault(require("./InterestBalancesTableComponent"));
var _interestBearingAccountsSelectors = require("../../../redux/selectors/interestBearingAccountsSelectors");
var _productPositionSelectors = require("../../../redux/selectors/productPositionSelectors");
var _positionActions = require("../../../redux/actions/positionActions");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var mapStateToProps = function mapStateToProps(state, _ref) {
  var rates = _ref.rates;
  var interestPayments = (0, _interestBearingAccountsSelectors.totaledInterestPaymentsSelector)(state);
  var rows = (0, _productPositionSelectors.productPositionAssetsSelector)(state).filter(function (i) {
    return Object.prototype.hasOwnProperty.call(rates, i.ProductId) && rates[i.ProductId].IsEnabled;
  });
  var totalValueRow = rows.reduce(function (acc, i) {
    acc.NotionalValue = acc.NotionalValue + i.NotionalValue;
    acc.Total += (0, _get["default"])(interestPayments, [i.ProductId, 'Total'], 0) * i.NotionalRate;
    acc['7DayEarnings'] += (0, _get["default"])(interestPayments, [i.ProductId, '7DayEarnings'], 0) * i.NotionalRate;
    return acc;
  }, _defineProperty({
    Total: 0,
    NotionalValue: 0
  }, '7DayEarnings', 0));
  return {
    rows: rows,
    totalValueRow: totalValueRow,
    interestPayments: interestPayments
  };
};
var mapDispatchToProps = {
  selectPositionAndSave: _positionActions.selectPositionAndSave
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_InterestBalancesTableComponent["default"]);